import { render } from "./CollectingOrders.vue?vue&type=template&id=7ecbe180&scoped=true"
import script from "./CollectingOrders.vue?vue&type=script&lang=js"
export * from "./CollectingOrders.vue?vue&type=script&lang=js"

import "./CollectingOrders.vue?vue&type=style&index=0&id=7ecbe180&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecbe180"]])

export default __exports__